import React, { useContext } from 'react';
import { Agentation } from 'agentation';
import './App.css';
import ContextAuth, { AuthContext } from './contextStore/AuthContext';
import AppProviders from './contextStore/AppProviders';
import MainRoutes from './Routes/MainRoutes';
import BarLoading from './Components/Loading/BarLoading';
import MaintenanceGate from './Components/Maintenance/MaintenanceGate';

function AppContent() {
  const { authLoading } = useContext(AuthContext);
  if (authLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <BarLoading />
      </div>
    );
  }
  return (
    <AppProviders>
      <MaintenanceGate>
        <MainRoutes />
      </MaintenanceGate>
      {process.env.NODE_ENV === 'development' &&
        process.env.NODE_ENV !== 'test' &&
        typeof window !== 'undefined' && <Agentation />}
    </AppProviders>
  );
}

function App() {
  return (
    <ContextAuth>
      <a href="#main-content" className="sebusca-skip-link">
        Pular para o conteúdo principal
      </a>
      <AppContent />
    </ContextAuth>
  );
}

export default App;
